module.exports = __webpack_public_path__ + "static/RamadanHearts-4c76e6ecbf73d2a670f562561d7b1984.jpg";